export enum JumpDirecton {
  Forward = "forward",
  Backward = "backward",
}

export interface JumpForwardBackwardButtonInterface {
  direction: JumpDirecton;
  isLarge?: boolean;
}
